export default "__VITE_ASSET__CvHQKDAL__"